module.exports = __webpack_public_path__ + "img/clockwise_ac.b6634df2.png";